import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import * as FormActions from '../../../actions/Forms.actions';
import * as UserAction from '../../../actions/User.actions';
import { PROVIDERS } from '../../../constants/Constant';
import '../../../styles/components/options/popups/edit_popup_content.scss';
import Button from '../../Button';

const AddSocialMedia = ({
	addSocialMedia,
	values,
	onSocialEditForm,
	onSocialInitForm,
	onSave,
}) => {
	const [selSocial, setSelSocial] = useState('facebook');

	useEffect(() => {
		Object.values(PROVIDERS).map((item, index) => {
			onSocialInitForm({ provider: item.name, url: item.domain });
		});
	}, []);

	const onChangeText = v => {
		onSocialEditForm({ provider: selSocial, url: v });
	};

	const handleSave = () => {
		addSocialMedia(
			{
				provider: selSocial,
				link: values[selSocial]?.url,
			},
			sus => {
				console.log(sus);
				onSave(sus);
			},

			err => {
				console.log(err);
			}
		);
	};
	const handleSelSocial = e => {
		let selected = e.target.getAttribute('itemProp');
		if (selected === null) {
			selected = e.target.parentNode.getAttribute('itemProp');
		}
		setSelSocial(selected);
	};

	return (
		<div className='edit_name_container'>
			<div className='input-wrapper'>
				<div className='input-container'>
					<div className='social-icon-container'>
						{Object.values(PROVIDERS).map((item, index) => (
							<div
								key={index}
								className={`icon ${selSocial == item?.name ? 'active' : ''}`}
								onClick={e => handleSelSocial(e)}
								itemProp={item?.name}
							>
								<img src={item?.icon} alt='' />
							</div>
						))}
					</div>
					<input
						type={'text'}
						name={'url'}
						id={'url'}
						value={values === undefined ? '' : values[selSocial]?.url}
						placeholder={`Your ${selSocial} account URL here`}
						onChange={e => onChangeText(e.target.value)}
					/>
				</div>
			</div>
			<div className='button-wrapper'>
				<Button
					active
					className='save-button'
					labal='Add'
					onClickEvent={() => handleSave()}
				></Button>
			</div>
		</div>
	);
};

const mapStateToProps = ({ user, forms }) => ({
	user,
	values: forms?.socialLinks,
});

const mapDispatchToProps = {
	updateProfile: UserAction.updateProfile,
	onSocialEditForm: ({ provider, url }) =>
		FormActions.addMediaForm({ provider, url }),
	onSocialInitForm: ({ provider, url }) =>
		FormActions.initMediaForm({ provider, url }),
	addSocialMedia: UserAction.addSocialMedia,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddSocialMedia);
